import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { makeStyles, Typography, Button, Link as MuiLink, ButtonBase } from "@material-ui/core";
import Link from "next/link";

import { STEP_CART } from "../../constants";
import GoBackIcon from "../../assets/goBackArrow.svg";

function FormActions({ submitText, prevStep, goBack, step, setSubmitFormik }) {
  const formik = useFormikContext();
  const classes = useStyle();

  useEffect(() => {
    if (setSubmitFormik) {
      setSubmitFormik(() => formik.submitForm);
    }
  }, [setSubmitFormik, formik.submitForm]);

  return (
    <>
      {submitText && (
        <div className={classes.actionContainer}>
          {step !== STEP_CART && !goBack && (
            <Link
              href={prevStep === STEP_CART ? "/reconditionne/panier" : `/reconditionne/panier/${prevStep}`}
              passHref
            >
              <MuiLink color="secondary" className={classes.link}>
                <GoBackIcon className={classes.backIcon} />
                <Typography>Retour</Typography>
              </MuiLink>
            </Link>
          )}
          {goBack && (
            <ButtonBase onClick={goBack}>
              <GoBackIcon className={classes.backIcon} />
              <Typography color="secondary">Retour</Typography>
            </ButtonBase>
          )}
          <Button variant="contained" color="primary" type="submit" disabled={formik.isSubmitting}>
            {submitText}
          </Button>
        </div>
      )}
    </>
  );
}

const useStyle = makeStyles((theme) => ({
  backIcon: {
    marginRight: theme.spacing(2),
  },
  link: {
    display: "flex",
    alignItems: "center",
  },
  actionContainer: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

export default FormActions;
